import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FocusNextDirective } from './focus-next.directive';
import { CopyClipboardDirective } from './copy-clipboard.directive';

@NgModule({
  declarations: [
    FocusNextDirective,
    CopyClipboardDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    FocusNextDirective,
    CopyClipboardDirective
  ]
})
export class DirectivesModule { }
